<template>
  <base-modal modal-content-class="unsub">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_unsubscribe_successfully_title }}</h1>

      <p>{{ $_getTranslations.home_modals_unsubscribe_successfully_description }}</p>

      <base-button container-class="resub_btn" @button:click="reOptin">
        {{ $_getTranslations.home_modals_unsubscribe_successfully_resubscribe_button }}
      </base-button>

      <p>
        {{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt1 }}
        <span class="white_bold">{{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt2 }}</span>
        {{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt3 }}
        <a :href="termsAndConditionsLink">{{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt4 }}</a>
        {{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt5 }}
      </p>
    </div>
  </base-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import BaseModal from '../../common/modal/BaseModal'
import BaseButton from '../../common/button/BaseButton'
import WelcomeReturningUnsub from './WelcomeReturningUnsub'
import ResubscribeViaPin from './ResubscribeViaPin'
import ResubscribeError from './store/ConfirmPurchaseForPinError'
import IntegrationMixin from '../../../common/mixins/integration'
import translationMixin from '../../../common/mixins/translation'
import modals from '../../../common/modals'

export default {
  name: 'resubscribe',
  mixins: [
    IntegrationMixin,
    translationMixin
  ],
  components: {
    BaseModal,
    BaseButton,
    WelcomeReturningUnsub,
    ResubscribeViaPin,
    ResubscribeError
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails'
    ]),
    ...mapMutations('common', [
      'storeModalForSettings'
    ]),
    ...mapActions('common', [
      'reOptinProcess'
    ]),
    async reSubCallback (response) {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        await this.getUserLoginDetails()

        if (this.reoptinOnestep) {
          if (this.userDetails.subscribed) {
            this.storeModalForSettings(WelcomeReturningUnsub)
          } else {
            this.storeModalForSettings(ResubscribeError)
          }
        } else {
          if (this.userDetails.subscribed) {
            this.storeModalForSettings(ResubscribeError)
          } else {
            this.storeModalForSettings(ResubscribeViaPin)
          }
        }
      } else {
        this.storeModalForSettings(ResubscribeError)
      }

      modals.showHideModalForHomePage(this)
    },
    reOptin () {
      this.getAppropriateReSubAction()
    }
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'reoptinOnestep'
    ]),
    termsAndConditionsLink () {
      return this.$_translateTextByOperator({key: 'project_config_visitor_register_3_terms_and_conditions'})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/home/modals/Resubscribe.vue